import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/ui/Button';

const Terms: FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-teaGreen/5 via-white to-primary-lightGreen/10">
      {/* Hero Section */}
      <section className="relative pt-20 pb-16 md:pt-24 md:pb-20 overflow-hidden">
        {/* Background Decorations */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-80 h-80 bg-primary-teaGreen/20 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-primary-lightGreen/20 rounded-full blur-3xl"></div>
        </div>

        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary-black mb-6 leading-tight">
              Terms & Conditions
            </h1>
            <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto mb-8 leading-relaxed">
              These Terms & Conditions ("Terms") govern your access and use of the Dhoondh platform and services offered by AMPS DHOONDH RECRUITMENT LLP. By using our services, you agree to comply fully with these Terms.
            </p>
            <p className="text-sm text-gray-500">
              Last updated: January 2025
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="relative pb-20 md:pb-32">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 md:p-12 shadow-xl border border-gray-100">
            
            {/* Purpose */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Purpose</h2>
              <p className="text-gray-700 leading-relaxed">
                Dhoondh operates as a recruitment and career enhancement platform, facilitating the exchange of information between employers and job seekers for legitimate job-related activities only.
              </p>
            </div>

            {/* Use of Platform */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Use of Platform</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>You may use the platform solely for job applications, recruitment, and career services.</li>
                <li>Misuse (including unauthorized scraping, copying, or sharing of data) is strictly prohibited.</li>
                <li>Unauthorized use may result in immediate termination and legal action.</li>
              </ul>
            </div>

            {/* User Responsibilities */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">User Responsibilities</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li><strong>Accurate Information:</strong> Users must provide true, updated, and accurate data. Dhoondh is not liable for false claims or inaccuracies.</li>
                <li><strong>Confidentiality:</strong> Users are responsible for maintaining the confidentiality of login credentials and activities under their account.</li>
                <li><strong>Prohibited Content:</strong> Users must not post unlawful, defamatory, obscene, or infringing content.</li>
                <li><strong>Data Use:</strong> By using the platform, you consent to Dhoondh using your data to provide recommendations, match jobs, and improve services.</li>
              </ul>
            </div>

            {/* Employers */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Employers</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Employers may post only genuine job vacancies.</li>
                <li>Resume database access must be used solely for recruitment purposes.</li>
                <li>Sharing or selling job seeker data without consent is prohibited.</li>
              </ul>
            </div>

            {/* Job Seekers */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Job Seekers</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>You are responsible for the accuracy of your resume and job application information.</li>
                <li>By applying, you authorize Dhoondh to share your application with employers.</li>
                <li>While Dhoondh guarantees support, employment itself is not guaranteed.</li>
              </ul>
            </div>

            {/* Payments & Refunds */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Payments & Refunds</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>All subscription services (e.g., premium listings, resume support) are prepaid.</li>
                <li>Refunds are governed by the Cancellation & Refunds Policy.</li>
              </ul>
            </div>

            {/* Intellectual Property */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Intellectual Property</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>All content, logos, designs, and platform material belong to AMPS Dhoondh LLP.</li>
                <li>User-generated content (resumes, job postings) grants Dhoondh a license to use, display, and distribute within its services.</li>
              </ul>
            </div>

            {/* Prohibited Activities */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Prohibited Activities</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Sending spam or unauthorized messages via the platform.</li>
                <li>Attempting to breach security, hack accounts, or tamper with listings.</li>
              </ul>
            </div>

            {/* Dispute Resolution & Governing Law */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Dispute Resolution & Governing Law</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>All disputes will be resolved through binding arbitration in Vadodara, Gujarat, India.</li>
                <li>These Terms are governed by the laws of Gujarat, India.</li>
              </ul>
            </div>

            {/* Termination of Services */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Termination of Services</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Dhoondh may suspend or terminate services for any violation of these Terms, without prior notice.</li>
              </ul>
            </div>

            {/* Limitation of Liability */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Limitation of Liability</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Dhoondh is not liable for indirect or incidental damages, including loss of data or opportunities.</li>
              </ul>
            </div>

            {/* Contact Information */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Contact Information</h2>
              <p className="text-gray-700 mb-4">
                If you have any questions about these Terms & Conditions, please contact us:
              </p>
              <div className="bg-primary-teaGreen/10 rounded-xl p-6">
                <p className="text-gray-700 mb-2">
                  <strong>Email:</strong> operations@dhoondh.in
                </p>
                <p className="text-gray-700 mb-2">
                  <strong>Phone:</strong> +91 93168 46322
                </p>
                <p className="text-gray-700">
                  <strong>Address:</strong> AMPS Dhoondh LLP, India
                </p>
              </div>
            </div>

            {/* Back to Home */}
            <div className="text-center pt-8 border-t border-gray-200">
              <Link to="/">
                <Button variant="outline" size="lg">
                  Back to Home
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
